export default "<div\r\n\tclass=\"markdown-container {{$ctrl.field.Variant}}\"\r\n\tng-bind-html=\"$ctrl.message\"\r\n>\r\n</div>";